"use client";

import { createProjectFilesHref } from "@/app/[locale]/[orgId]/[teamId]/(main)/files/projects/utils";
import { useAuthenticatedLaunchDarklyContextReady } from "@/app/providers/LaunchDarklyProvider/LaunchDarklyProvider";
import { useFeatureFlags } from "@/hooks/useFeatureFlags";
import { useOrganization } from "@/hooks/useOrganization";
import { useTrialOnboardingProgress } from "@/hooks/useTrialOnboardingProgress/useTrialOnboardingProgress";

export function useResumeTrialOnboarding() {
  const contextReady = useAuthenticatedLaunchDarklyContextReady();
  const flags = useFeatureFlags();
  const { currentTrial, isLoading: isLoadingOrganization } = useOrganization();
  const showUploadOnboarding =
    contextReady && flags["trials-plg-optimization-pd-6"] && currentTrial?.status === "ACTIVE";
  const { progress, isLoading, error } = useTrialOnboardingProgress(
    showUploadOnboarding ? currentTrial?.id : undefined,
  );
  const upload = showUploadOnboarding ? progress?.state.upload : undefined;
  const shouldResume = upload && !error && progress?.completed === false;

  return {
    isLoading: !contextReady || isLoadingOrganization || (showUploadOnboarding && isLoading),
    projectId: shouldResume ? upload.projectId : undefined,
    uploadProjectId: upload && !error ? upload.projectId : undefined,
    href: shouldResume
      ? `${createProjectFilesHref({ projectId: upload.projectId, scopeId: upload.projectScopeId, scopeType: "PROJECT" })}&assist=1`
      : undefined,
  };
}
